import { Pipe, PipeTransform } from "@angular/core";
import { AbstractControl, FormArray, FormControl, FormGroup } from "@angular/forms";

@Pipe({
    name: 'asFormGroupPipe'
})
export class AsFormGroupPipe implements PipeTransform {
    transform(object: AbstractControl): FormGroup | undefined {
        return object instanceof FormGroup
        ? object
        : undefined
    }
}

@Pipe({
    name: 'asFormArrayPipe'
})
export class AsFormArrayPipe implements PipeTransform {
    transform(object: AbstractControl): FormArray | undefined {
        return object instanceof FormArray
        ? object
        : undefined
    }
}
@Pipe({
    name: 'asFormControlPipe'
})
export class AsFormControlPipe implements PipeTransform {
    transform(object: AbstractControl): FormControl | undefined {
        return object instanceof FormControl
        ? object
        : undefined
    }
}
